import { render, staticRenderFns } from "./TabDossierResultHours.vue?vue&type=template&id=25335d54"
import script from "./TabDossierResultHours.vue?vue&type=script&setup=true&lang=js"
export * from "./TabDossierResultHours.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports